import isVerifyTokenGuard from "@/guards/verifyTokenGuard";

export default {
    name: 'catalog-diagnostics',
    component: () => import(/* webpackChunkName: "base-layout" */ '@/layouts/BaseLayout.vue'),
    children: [
        {
            path: '',
            name: 'catalog-diagnostics-index',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [
                                        {
                        transKey: 'breadcrumbs.official-catalogs',
                        isActive: false
                    },
                    {
                        transKey: 'breadcrumbs.catalog-diagnostics-index',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "catalog-diagnostics-index" */ '@/modules/configurations/catalogs/catalog-diagnostics/views/Index.vue')
        },
        // HCSO-2909 · FR-010: el catálogo CIE-10 es de solo lectura; cualquier URL
        // de alta/edición/baja (marcadores viejos) regresa al listado con aviso.
        {
            path: ':pathMatch(.*)+',
            redirect: () => ({ name: 'catalog-diagnostics-index', params: {}, query: { readonly: '1' } })
        }
    ]
}
